import '../../common_screen/my_contest_tab/index_mWeb.css';
import FlatList from 'flatlist-react';
import { FlatListWrapper, PaginationIndicator } from '../../../component';
import { ContestShare } from '../../component';
import ContestCardMWeb from '../../component/contest_card/index_mWeb';
import PullToRefresh from 'react-simple-pull-to-refresh';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const MyContestListMWeb = ({
  challenges,
  onPressCard,
  onPressShare,
  matchItem,
  totalTeamsCount,
  gameState,
  gameType,
  matchStatus,
  contestLink,
  contestTitle,
  contestShare,
  onPressShareModalDismiss,
  matchDelayed
}: any) => {
  ///code

  const renderItem = (item: any) => (
    <ContestCardMWeb
      key={item._id}
      contest={item}
      onPressCard={() => onPressCard(item, false)}
      matchStatus={matchStatus}
      onPressShare={() => onPressShare()}
      matchItem={matchItem}
      totalTeamsCount={totalTeamsCount}
      screenName={'MY_JOINED_CONTEST'}
      matchDelayed={matchDelayed}
      gameState={gameState}
      gameType={gameType}
    />
  );

  const onRefresh = async () => {
    // setSkip(0);
    // setHasMoreItems(false);
  };

  return (
    <ScreenBackgroundWrapper>
      <PullToRefresh className="my-contest-list-flat-list-wrapper_mWeb" onRefresh={onRefresh}>
        <FlatListWrapper>
          <FlatList
            list={challenges}
            renderItem={renderItem}
            // renderWhenEmpty={renderWhenEmpty}
            // hasMoreItems={hasMoreItems}
            // loadMoreItems={loadMoreItems}
            // renderOnScroll
            paginationLoadingIndicator={<PaginationIndicator />}
          />
        </FlatListWrapper>
      </PullToRefresh>
      <ContestShare
        link={contestLink}
        contestTitle={contestTitle}
        visible={contestShare}
        onPressDismiss={onPressShareModalDismiss}
      />
    </ScreenBackgroundWrapper>
  );
};

export default MyContestListMWeb;
